module.exports = __webpack_public_path__ + "img/system_1.25680f3c.svg";